export default "__VITE_PUBLIC_ASSET__453e79e6__"